import { DestroyRef, Injectable, NgZone } from '@angular/core';
//import posthog from 'posthog-js';
import { environment } from 'src/environments/environments';
import { Router } from "@angular/router";

@Injectable({ providedIn: 'root' })
export class PosthogService {
  constructor(
    private ngZone: NgZone,
    private router: Router,
    private destroyRef: DestroyRef
  ) {
    //this.initPostHog();
  }

  /*private initPostHog() {
    if (!environment.production) return;
    this.ngZone.runOutsideAngular(() => {
      posthog.init(environment.postHogKey, {
        api_host: environment.postHogHost,
        defaults: '2026-01-30',
      });
    });
  }*/
}
